import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const TikTokIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-tiktok${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    x={x}
    y={y}
  >
    <title>TikTok</title>
    <path
      d="M6.28414 8.22244C5.32866 8.22244 4.55675 8.99436 4.57087 9.94042C4.58028 10.5476 4.91447 11.0748 5.40633 11.369C5.23923 11.1125 5.14039 10.8088 5.13568 10.4817C5.12156 9.53563 5.89348 8.76372 6.84896 8.76372C7.03723 8.76372 7.21844 8.79432 7.38789 8.84845V6.95395C7.21138 6.92806 7.03017 6.91394 6.84896 6.91394C6.83954 6.91394 6.83249 6.91394 6.82307 6.91394V8.30716C6.65363 8.25304 6.47241 8.22244 6.28414 8.22244Z"
      fill="var(--color-brand-tiktok-3)"
      id="icon-logo-3-fill"
    />
    <path
      d="M10.4142 2.54126H10.4002H9.91064C10.0518 3.24964 10.4496 3.86623 11.005 4.28514C10.6402 3.80269 10.419 3.20022 10.4142 2.54126Z"
      fill="var(--color-brand-tiktok-3)"
      id="icon-logo-3-fill"
    />
    <path
      d="M13.295 5.42421C13.1091 5.42421 12.9302 5.40538 12.7537 5.37244L9.85904 5.74428L6.82315 13.4188C6.64664 13.4447 6.46543 13.4588 6.28421 13.4588C5.47935 13.4588 4.71215 13.1975 4.0885 12.7151C4.1591 12.7998 4.23441 12.8822 4.31678 12.9622C4.99455 13.6306 5.89355 14 6.85139 14C7.03259 14 7.21381 13.9859 7.39031 13.96C8.1434 13.8494 8.83765 13.5035 9.38603 12.9622C10.0591 12.2961 10.4309 11.4137 10.4356 10.4723L10.4003 6.28556C10.7203 6.53267 11.0711 6.73977 11.4499 6.89745C12.0359 7.14455 12.6572 7.27164 13.295 7.27164"
      fill="var(--color-brand-tiktok-3)"
      id="icon-logo-3-fill"
    />
    <path
      d="M4.30968 7.95653C4.9804 7.29051 5.87234 6.92103 6.82311 6.91397V6.41269C6.64661 6.3868 6.46539 6.37268 6.28419 6.37268C5.324 6.37268 4.42265 6.74217 3.74487 7.41525C3.07886 8.07655 2.69761 8.98026 2.69996 9.91928C2.69996 10.8653 3.07416 11.7526 3.74958 12.4233C3.85783 12.5292 3.96845 12.6281 4.08612 12.7175C3.55425 12.0844 3.26478 11.2937 3.26243 10.4605C3.26478 9.52157 3.64368 8.61784 4.30968 7.95653Z"
      fill="var(--color-brand-tiktok-2)"
      id="icon-logo-2-fill"
    />
    <path
      d="M12.7536 5.37243V4.8688H12.749C12.0947 4.8688 11.4922 4.65229 11.0074 4.28516C11.4287 4.84056 12.0453 5.23594 12.7536 5.37243Z"
      fill="var(--color-brand-tiktok-2)"
      id="icon-logo-2-fill"
    />
    <path
      d="M6.75239 12.148C6.97596 12.1597 7.19012 12.1291 7.38781 12.0656C8.07029 11.842 8.56215 11.2065 8.56215 10.4582L8.5645 7.65761V2.54129H9.91062C9.87538 2.36478 9.85655 2.18592 9.85414 2H7.99969V7.11398L7.99733 9.91452C7.99733 10.6629 7.50548 11.2983 6.82299 11.5219C6.62531 11.5878 6.41115 11.6184 6.18758 11.6043C5.90281 11.5878 5.63688 11.5031 5.40625 11.3666C5.69571 11.8137 6.18993 12.1173 6.75239 12.148Z"
      fill="var(--color-brand-tiktok-2)"
      id="icon-logo-2-fill"
    />
    <path
      d="M6.82311 13.4187C7.5762 13.3082 8.27045 12.9622 8.81879 12.4209C9.49187 11.7549 9.86367 10.8723 9.86841 9.93098L9.859 5.74425C10.1791 5.99137 10.5297 6.19847 10.9086 6.35614C11.4946 6.60325 12.1159 6.73034 12.7536 6.73034V5.37241C12.0453 5.23592 11.4287 4.84054 11.0075 4.28514C10.4521 3.86623 10.0519 3.24963 9.91315 2.54126H8.56463V7.65523L8.56228 10.4558C8.56228 11.2042 8.07041 11.8396 7.38793 12.0631C7.19024 12.129 6.97609 12.1597 6.75251 12.1455C6.1877 12.115 5.69584 11.8114 5.40637 11.3665C4.91451 11.0747 4.58033 10.5452 4.57092 9.93806C4.5568 8.99197 5.32871 8.22005 6.28419 8.22005C6.47246 8.22005 6.65367 8.25065 6.82311 8.30477V6.91155C5.87234 6.91861 4.98041 7.28809 4.30969 7.95411C3.64368 8.61542 3.26243 9.51912 3.26478 10.4558C3.26478 11.2889 3.55425 12.0796 4.08847 12.7127C4.71447 13.1952 5.47933 13.4564 6.28419 13.4564C6.4654 13.4588 6.64661 13.4446 6.82311 13.4187Z"
      fill="var(--color-brand-tiktok-1)"
      id="icon-logo-1-fill"
    />
  </OpticksSvgElement>
);

export default TikTokIcon;
